import { config } from '@air/api';

if (typeof window !== 'undefined' && process.env.NEXT_PUBLIC_API_DEBUG_MODE_ENABLED === 'true') {
  config.setDebugMode(true);
}
